import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		init: false,
		notifications: null,
		telegram: null,
	},
	getters: {
		notifications(state) {
			return state.notifications;
		},
		telegram(state) {
			return state.telegram;
		},
	},
	mutations: {
		ACCESS_TOKEN(state, accessToken) {
			state.access_token = accessToken
		},
		SET_NOTIFICATIONS(state, Notifications) {
			state.notifications = Notifications
		},
		SET_TELEGRAM(state, Telegram) {
			state.telegram = Telegram
		},
		SET_INIT(state, init) {
			state.init = init
		},
		CLEAR_STORE(state) {
			state.init = null;
			state.notifications = null;
			state.telegram = null;
		}
	},
	actions: {
		init({commit, state}) {
			return new Promise((resolve, reject) => {
				if (state.init) {
					resolve();
				} else {
					apiClient.get('settings/notifications/get').then(res => {
						commit('SET_NOTIFICATIONS', res.data);
						commit('SET_INIT', true);
						resolve();
					}).catch(err => {
						reject(err);
					});
				}
			})
		},
		updateNotificationsSettings({commit}, notifications) {
			return new Promise((resolve, reject) => {
				apiClient.put('settings/notifications/update', notifications).then(res => {
					commit('SET_NOTIFICATIONS', res.data);
					commit('SET_INIT', false);
					this.init;
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		getTelegram({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('settings/notifications/telegram').then(res => {
					commit('SET_TELEGRAM', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			})
		},
		async clear({commit}) {
			commit('CLEAR_STORE');
		}
	}
}
